// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3hNtE";
var _3 = "header-1Pohf";
var _4 = "segmentInfo-nhFyI";
var _5 = "segmentInfo__item-3ohz3";
var _6 = "planeIcon-2mCX5";
var _7 = "fareFamily-UEI2S";
var _8 = "fareFamily__img-2Ftz3";
var _9 = "footer-1ZmJD";
var _a = "flightInfo-3N-4Y";
var _b = "flightInfo__item-2bLdP";
export { _1 as "__esModule", _2 as "wrapper", _3 as "header", _4 as "segmentInfo", _5 as "segmentInfo__item", _6 as "planeIcon", _7 as "fareFamily", _8 as "fareFamily__img", _9 as "footer", _a as "flightInfo", _b as "flightInfo__item" }
export default { "__esModule": _1, "wrapper": _2, "header": _3, "segmentInfo": _4, "segmentInfo__item": _5, "planeIcon": _6, "fareFamily": _7, "fareFamily__img": _8, "footer": _9, "flightInfo": _a, "flightInfo__item": _b }
